// ─────────────────────────────────────────────────────────────────
// Glass-i — Unposted Purchase Bills side-effect guard helper.
//
// Tiny pure module extracted so the node:test harness can import the
// guard without parsing the React JSX of UnpostedPurchaseBillsPage.
// The page imports the same symbol — single source of truth.
//
// Bug class pinned by ./UnpostedPurchaseBillsPage.guard.test.js:
//
//   When /erp/purchase-accounting/unposted-bills mounts with an empty
//   list, any side-effect API call that round-trips a stale
//   `undefined` / "undefined" / empty / literal `:id` string lands at
//   a backend route guarded by `assertUuid('id', ...)` and produces
//   the toast:
//
//       "id must be a valid UUID."
//
// This helper is the single gate every such call must pass through.
// ─────────────────────────────────────────────────────────────────

// Same regex shape as the backend's `assertUuid` so the frontend
// rejects exactly what the backend would reject (no false negatives,
// no double-fetch noise). Kept here verbatim instead of importing the
// backend module to keep the bundle free of server-side code.
const UUID_LIKE_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function shouldFetchStatusFor(id) {
  if (id === null || id === undefined) return false;
  if (typeof id !== 'string') return false;
  const trimmed = id.trim();
  if (trimmed === '') return false;
  // Common React-routing accidents — these would round-trip through
  // encodeURIComponent intact and hit the backend as a literal string.
  if (trimmed === 'undefined')        return false;
  if (trimmed === 'null')             return false;
  if (trimmed === ':id')              return false;
  if (trimmed === ':billId')          return false;
  if (trimmed === ':purchaseBillId')  return false;
  return UUID_LIKE_RE.test(trimmed);
}

export default { shouldFetchStatusFor };
